import {
  essityCatalogTranslationsModule,
  essityCatalogOverridesModule,
  essityApiDocsOverridesModule,
  essityCatalogGraphOverridesModule,
  essityScaffolderOverridesModule,
  essityApiValidationReportModule,
} from './modules';

export const essityCatalogPlugin = [
  essityCatalogTranslationsModule,
  essityCatalogOverridesModule,
  essityApiDocsOverridesModule,
  essityCatalogGraphOverridesModule,
  essityScaffolderOverridesModule,
  essityApiValidationReportModule,
];
